<template>
  <div>
    <div class="function-bar" ref="staticFunctionBar">
      <div class="function-bar__container">
        <ul class="function-bar__items function-bar__items_row">
          <li class="function-bar__item" id="item-calculator">
            <div class="function-bar__top">
              <svg class="calc-icon" width="32px" height="38px">
                <use xlink:href="#icon-calc"></use>
              </svg>

              <h4 class="function-bar__title">Рассчитать<br>стоимость</h4>
            </div>

            <ButtonScroll
              :title="'Расcчитать'"
              :nameButton="'calc button button_red'"
              :scrollSelector="'#calculator'"
              :topMarginScroll="50"
            />
          </li>
          <li class="function-bar__item" id="item-map-send">
            <div class="function-bar__top">

              <svg class="geo" width="31px" height="38px">
                <use xlink:href="#geo-thin"></use>
              </svg>

              <h4 class="function-bar__title">Наши<br>отделения</h4>
            </div>
            <ButtonScroll
              :title="'Показать отделения'"
              :nameButton="'branch button button_red'"
              :scrollSelector="'.map__find-branch'"
              :topMarginScroll="70"
            />

          </li>
          <li class="function-bar__item" id="item-tracking">
            <div class="function-bar__top">

              <svg class="search-thin-icon" width="40px" height="38px">
                <use xlink:href="#mobile-find-track"></use>
              </svg>

              <h4 class="function-bar__title">Отследить<br>посылку</h4>
            </div>

            <div class="field-input">
              <input class="field-input__inner"
                     placeholder="Трек-номер"
                     required=""
                     type="text"
                     autocomplete="new-password"
                     v-model="track"
                     @keyup.enter="onTrackFind"
              >

              <b-button class="button button_red" @click="onTrackFind">
                <span>
                  <svg class="search-thin-icon" width="32px" height="32px">
                    <use xlink:href="#search-thin"></use>
                  </svg>
                </span>
              </b-button>
            </div>

          </li>
          <li class="function-bar__item" id="item-join">
            <div class="function-bar__top">

              <svg class="join" width="33px" height="42px">
                <use xlink:href="#join-icon"></use>
              </svg>

              <h4 class="function-bar__title">Подключись<br>к Boxberry</h4>
            </div>
            <ButtonScroll
              :title="'Подключиться'"
              :nameButton="'join-boxberry'"
              :scrollSelector="'#form_ecom'"
              :topMarginScroll="50"
            />

          </li>
        </ul>
      </div>
    </div>
    <transition name="formbar-fixed-moved">
      <div class="function-bar"
           :class="{'function-bar__fixed': showFixedBar}"
           v-if="showFixedBar"
           ref="fixedFunctionBar"
      >
        <div class="function-bar__container">
          <div class="arrows arrows_with-padding arrows_red">

            <div class="arrow arrow_left" @click="() => horizontalScrollBar()">
              <svg class="arrow-icon" width="24px" height="14px">
                <use xlink:href="#arrow"></use>
              </svg>
            </div>

            <div class="arrow arrow_right" @click="() => horizontalScrollBar(true)">
              <svg class="arrow-icon" width="24px" height="14px">
                <use xlink:href="#arrow"></use>
              </svg>
            </div>

          </div>

          <ul class="function-bar__items function-bar__items_row">
            <li id="item-calculator" class="function-bar__item">
              <ButtonScroll
                :title="'Расcчитать стоимость'"
                :nameButton="'calc'"
                :nameImage="'calc'"
                :scrollSelector="'#calculator'"
                :topMarginScroll="50"
              />
            </li>
            <li id="item-map-send" class="function-bar__item">
              <ButtonScroll
                :title="$t('nashi-otdeleniya')"
                :nameButton="'branch'"
                :nameImage="'geo-thin'"
                :scrollSelector="'.map__find-branch'"
                :topMarginScroll="70"
              />
            </li>
            <li id="item-tracking" class="function-bar__item">
              <ButtonRoute
                :title="$t('otsledit-posylku')"
                :nameButton="'tracking-package'"
                :nameImage="'search-thin'"
                :route="'/tracking-page'"
              />
            </li>
            <li id="item-join" class="function-bar__item">
              <ButtonScroll
                :title="'Подключиться к Boxberry'"
                :nameButton="'join-boxberry'"
                :nameImage="'join-icon'"
                :scrollSelector="'#form_ecom'"
                :topMarginScroll="50"
              />
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
/* global $ */
import ButtonScroll from '@/components/ComponentsFunctionBar/ButtonScroll.vue';
import ButtonRoute from '@/components/ComponentsFunctionBar/ButtonRoute.vue';

export default {
  name: 'FunctionbarDesktop',
  components: {
    ButtonScroll,
    ButtonRoute,
  },
  mounted() {
    this.initBar();
  },
  data() {
    return {
      track: '',
      showFixedBar: false,
    };
  },
  methods: {
    initBar() {
      const self = this;
      this.onShowFixedBar();

      document.addEventListener('scroll', () => {
        self.onShowFixedBar();
      });
    },
    onTrackFind() {
      document.dispatchEvent(new CustomEvent('startSearchTrack', { detail: { track: this.track } }));
    },
    onShowFixedBar() {
      const header = document.querySelector('.header');

      if (this.$refs.staticFunctionBar && header) {
        const functionBarTop = $(this.$refs.staticFunctionBar).offset().top;
        const functionBarHeight = this.$refs.staticFunctionBar.offsetHeight;
        const windowTop = window.scrollY + header.offsetHeight;

        this.showFixedBar = windowTop > functionBarTop + functionBarHeight && window.innerWidth > 580;
      }
    },
    horizontalScrollBar(right) {
      const scrollSize = $(this.$el).find('.function-bar__fixed .function-bar__item')[0].offsetWidth * 2;
      const scrollBlock = $(this.$el).find('.function-bar__fixed .function-bar__items.function-bar__items_row')[0];
      if (right) {
        scrollBlock.scrollTo({ left: scrollSize, behavior: 'smooth' });
      } else {
        scrollBlock.scrollTo({ left: 0, behavior: 'smooth' });
      }
    },
  },
};
</script>
